import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiButtonPluginKey: PluginKey = new PluginKey('aiExperienceAIButton');
